import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {
  makeGoalStaticsTeamData,
  makeHeaderRow,
} from '../../utils/goal_statics';
import GoalStaticsTeamTable from '../../components/goal_statics/GoalStaticsTeamTable';
import * as staticsApi from '../../lib/api/statics';

const GoalStaticsTeamContainer = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  // const onLoadData = () => {
  //   setLoading(true);
  //   const loadedHeaders = makeHeaderRow(strMonth, endMonth);
  //   const loadedData = makeGoalStaticsTeamData(loadedHeaders);
  //   setHeaderRows(loadedHeaders);
  //   setData(loadedData);
  //   setLoading(false);
  //   console.log(JSON.stringify(loadedData), 'emp');
  // };

  const onLoadData = async () => {
    setLoading(true);

    try {
      const loadedHeaders = makeHeaderRow(strMonth, endMonth);
      const res = await staticsApi.getDepartExpectStatics(
        selectedYear,
        strMonth,
        endMonth,
        selectedGbn,
      );
      if (res.data.list) {
        setHeaderRows(loadedHeaders);
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);
  return (
    <GoalStaticsTeamTable
      data={data}
      loading={loading}
      headerRows={headerRows}
      tableRef={tableRef}
    />
  );
};

export default GoalStaticsTeamContainer;
